import { getAllResults } from 'owa-timestream-search-store';
import compareResults from '../utils/compareResults';
import { currentSearchPivotKey, currentFilterKey } from '../selectors/searchViewSelectors';
import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import { getSearchableAsset } from 'owa-timestream-asset-search';
import type Message from 'owa-service/lib/contract/Message';

export default function searchItems(): SearchResultItem[] {
    const selectedKey = currentSearchPivotKey();
    let resultsForKey = getAllResults().get(selectedKey);

    if (!resultsForKey || resultsForKey.length === 0) {
        return [];
    }

    const searchableAsset = getSearchableAsset(selectedKey);

    // only filter assets if there's a selected filter key
    if (currentFilterKey() && searchableAsset) {
        const filterOption = searchableAsset
            .getResultFilterOptions()
            .filter(option => option.id === currentFilterKey())[0];
        if (filterOption) {
            resultsForKey = resultsForKey.filter(filterOption.filter);
        }
    }

    // exclude sticky notes from search
    resultsForKey = resultsForKey.filter(result => {
        if (result.type === 'mailItem') {
            const mailItem = result.data as Message;
            return mailItem?.ItemClass !== 'IPM.StickyNote';
        }
        return true;
    });

    if (resultsForKey?.length > 0) {
        // get all headers for the asset type if there's any results left
        resultsForKey.push(...searchableAsset.getSearchResultHeaders(resultsForKey));
    }

    return resultsForKey.sort(compareResults);
}
